import React from 'react';
import { Link } from 'react-router-dom';

import { $ } from 'jquery';
import Swal from 'sweetalert2';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import { FaEdit, FaEye } from 'react-icons/fa';
import 'react-datepicker/dist/react-datepicker.css';
import {
  getallUser,
  GetServiceFilter,
  getBusinessListing,
} from '../../../actions/homeAction';
import moment from 'moment';

class UserList extends React.Component {
  state = {
    statusFilter: '',
    serviceFilter: '',
    userFilter: '',
    startDate: '',
    userList: [],
    businessList: [],
    // editUser: true
  };

  handleServiceFilter = (data) => {
    this.setState({ serviceFilter: new Date().toDateString(data) });
  };

  handleUserFilter = (data) => {
    this.setState({ userFilter: data });
  };

  handleDateFilter = (data) => {
    this.setState({ startDate: data });
  };

  handlestatusFilter = (data) => {
    this.setState({ statusFilter: data });
  };
  oncancelButton = () => {
    this.props.getallUser();
    this.setState({
      cancelButton: false,
      startDate: '',
      statusFilter: '',
      userFilter: '',
      serviceFilter: '',
    });
  };

  onGo = () => {
    var serviceType =
      this.state.serviceFilter !== 'All' ? this.state.serviceFilter : '';
    var userType = this.state.userFilter !== 'All' ? this.state.userFilter : '';
    var statusType =
      this.state.statusFilter !== 'All' ? this.state.statusFilter : '';
    var RegDate = this.state.startDate !== 'All' ? this.state.startDate : '';

    this.props.getallUser(serviceType, userType, RegDate, statusType);
    this.setState({
      cancelButton: true,
    });
  };

  handleStatusChange = (sid) => {
    console.log('78asd78asd', this.props.home.userList);
    console.log('sid', sid);
    // var isChecked = $('#cattogBtn_' + sid);
    // var status= ' '
    // isChecked.prop('checked', !isChecked.prop('checked'));
    // //console.log(isChecked.prop('checked'), !isChecked.prop('checked'));
    // if (!isChecked.prop('checked') === true) {
    // 	status = 'active';
    // } else {
    // 	status = 'inactive';
    // }
    // let newArray = this.state.user_list;
    // var a = newArray.find(element => {
    // 	return element.id === sid;
    // });
    // a.status = status;
    // //console.log(newArray);
    // this.setState({ user_list: newArray });
    // Swal.fire('Update Status!', 'Status has been updated.', 'success');
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.home.userList !== undefined) {
      let businessList = [];
      let userList = this.props.home.userList;
      //console.log("userList")
      this.setState({
        userList,
      });
      if (this.props.home.businessList !== undefined) {
        businessList = this.props.home.businessList.data.response;
      }
      this.setState({ businessList });
    }
  }
  componentDidMount() {
    this.props.getallUser('', 'user', '', '');
    this.props.getBusinessListing();
  }

  componentDidUpdate() {
    if (this.props.home.businessList === undefined) {
      this.props.getBusinessListing();
    }
  }

  imgLoadError = (event) => {
    event.target.src = './assets/images/icon.png';
  };

  render() {
    const columns = [
      {
        name: 'username',
        label: 'User Name',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'firstName',
        label: 'First Name',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },

      {
        name: 'lastName',
        label: 'Last Name',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },
      {
        name: 'mobileNumber',
        label: 'Phone No',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'userType',
        label: 'User Type',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },
      {
        name: 'mobileVerified',
        label: 'Mobile Verified',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (mobileVerified) => {
            return (
              <div className={mobileVerified ? 'text-success' : 'text-danger'}>
                {mobileVerified ? 'Verified' : 'Not-Verified'}
              </div>
            );
          },
        },
      },
      {
        name: 'createdAt',
        label: 'Date of Registration',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (createdAt) => {
            return moment(createdAt).format('DD/MM/YYYY , hh:mm A');
          },
        },
      },
      {
        name: 'activeAdsCount',
        label: 'Active Ads',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'expiredAdsCount',
        label: 'Expired Ads',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'totalPaidAmount',
        label: 'Amount Paid',
        options: {
          filter: false,
          sort: true,
        },
      },
      // {
      // 	name: '5',
      // 	label: 'Action',
      // 	options: {
      // 		filter: true,
      // 		sort: true,
      // 		display: false,
      // 		customBodyRender: (id, tableMeta) => {
      // 			return (
      // 				<div>
      // 					<Link
      // 						to={'/user/add/:user_id?'}
      // 						className='m-r-15 text-muted'
      // 						data-toggle='tooltip'
      // 						data-placement='top'
      // 						title=''
      // 						data-original-title='Edit'>
      // 						<i className='f-20 icofont icofont-ui-edit text-custom'></i>
      // 					</Link>
      // 					<Link
      // 						to={'/user/View/'}
      // 						// onClick={this.deleteUser.bind(this, id)}
      // 						className='m-r-15 text-muted'
      // 						data-toggle='tooltip'
      // 						data-placement='top'
      // 						title=''
      // 						data-original-title='View'>
      // 						<i className='f-26 icofont icofont-eye text-black'></i>{' '}
      // 					</Link>
      // 				</div>
      // 			);
      // 		},
      // 	},
      // },

      {
        name: 'status',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (status, tableMeta) => {
            return (
              <div
                className={status === 'active' ? 'st-active' : 'st-inactive'}
              >
                {status === 'active' ? 'Active' : 'In-Active'}
              </div>
            );
          },
        },
      },
      {
        name: 'userId',
        label: 'Actions',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (userId) => {
            return (
              <div>
                <Link to={`/user/view/${userId}`} title="View">
                  <FaEye style={{ fontSize: '1.4rem' }} />
                </Link>
              </div>
            );
          },
        },
      },
    ];

    const options = {
      filter: false,

      viewColumns: false,
      print: false,
      download: false,
      search: true,
      selectableRows: 'none',
    };

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header"></div>
                  <div className="card-block">
                    <div className="dt-responsive table-responsive">
                      {this.props.home.userList !== undefined ? (
                        <MUIDataTable
                          title={'User List'}
                          className="table-responsive"
                          data={this.props.home.userList}
                          columns={columns}
                          options={options}
                        />
                      ) : (
                        <h4>Loading...</h4>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserList.propsTypes = {
  getallUser: PropTypes.func.isRequired,
  GetServiceFilter: PropTypes.func.isRequired,
  getBusinessListing: PropTypes.func.isRequired,
};
var mapStateToProps = (state) => {
  return {
    home: state.home,
  };
};

export default connect(mapStateToProps, {
  getallUser,
  GetServiceFilter,
  getBusinessListing,
})(UserList);
